
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { withFirebase } from '../../hoc';
import { Loading } from '../common';
const OrderEventsContext = React.createContext({});
let autoRefreshInterval;

class OrderEvents extends React.Component {
  _observer = null
  state = {
      events: [],
      loading: false, // should be true
      ts: moment().startOf('day').format('YYYY-MM-DD 00:00:00'),
      isMounted: true // should be false
  }

    _getChangesInfo = (changes) => {
        let results = []
        changes.forEach((change) => {
            if (change.type === 'added' || change.type === 'modified') {
                results.push(change.doc.data())
            }
        });
        return results;
    }
    async componentDidMount () {
       // const { isMounted, firebase } = this.state;
        /*     try {
        const { isMounted } = this.state
        const { firebase } = this.props
        const _docRef = firebase.collection('order-events').where('ts', '>=', moment().startOf('day').format('YYYY-MM-DD 00:00:00'))
        this._observer = _docRef.onSnapshot(docSnapshot => {
            let changes = docSnapshot.docChanges()
            let newChanges = this._getChangesInfo(changes)
            if (changes.fromCache) {
            return
            }
            if (size(newChanges) || !isMounted) {
            this.setState({
                ts: new Date().toISOString(),
                events: newChanges,
                loading: false,
                isMounted: true
            })
            }

            // ...
        }, err => {
            console.log(`Encountered error: ${err}`)
        })
        } catch (error) {
        console.log(error)
        } */
        this.autoRefresh();
    }

    autoRefresh = () => {
        clearInterval(autoRefreshInterval);
        autoRefreshInterval = setInterval(() => {
            console.log('updating event');
            this.setState({
                ts: new Date().toISOString()
            });
        }, 60000);
    }

    componentWillUnmount () {
        console.log('leaving');
        typeof this._observer === 'function' && this._observer();
        clearInterval(autoRefreshInterval);
    }

    render () {
        const { children } = this.props;
        const { events, loading, ts } = this.state;
        return (
            <Loading loading={loading}>
                <OrderEventsContext.Provider value={{ events, loading, ts }}>
                    {children}
                </OrderEventsContext.Provider>
            </Loading>

        );
    }
}

OrderEvents.propTypes = {
    children: PropTypes.any,
    firebase: PropTypes.object
};

export const OrderEventsConsumer = OrderEventsContext.Consumer;
export default withFirebase(OrderEvents)
